export default __webpack_public_path__ + "static/hw_ff_ds18b20-9571cd02a67a39332beaa5ff71dbea47.png";